import { useTranslations } from 'next-intl'
import { Switch } from '@/components/switch'
import { T } from '@/components/t'
import { useRestaurantCitySearchContext } from '@/features/restaurants/restaurants-city-search/utils/restaurant-city-search-context'

export const RestaurantCitySearchFiltersOpenNow = () => {
    const {
        query: { openNow },
        setters: { setOpenNow },
    } = useRestaurantCitySearchContext()

    const t = useTranslations()

    return (
        <div className="flex flex-row items-center gap-x-8">
            <T span className="hidden md:inline-block" t="restaurants.city.filterBy" />

            <Switch
                label={t('restaurants.city.openRestaurantsFilterLabel')}
                checked={openNow ?? false}
                onToggle={() => setOpenNow(!openNow)}
            />
        </div>
    )
}
